var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSquare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_133_4205",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 92
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.333336,
    width: 91.6667,
    height: 91.6666,
    rx: 12,
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_133_4205)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -30.9167,
    y: -30.8333,
    width: 154,
    height: 154,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.2561 73.0812L89.2465 73.1449C89.2465 82.8219 81.3298 90.7394 71.6539 90.7394H18.876C9.20001 90.7394 1.28335 82.8219 1.28335 73.1449V20.3612C1.28335 10.6842 9.20005 2.76667 18.876 2.76667H71.6538C81.3298 2.76667 89.2465 10.6842 89.2465 20.3612V40.3879L89.2561 73.0812Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7334 66.5072C82.3414 85.0638 89.2561 73.1449 89.2561 73.1449C89.2561 75.0807 88.9393 76.9462 88.3548 78.692C86.0179 85.6728 79.4027 90.7394 71.6616 90.7394H18.8779C9.20087 90.7394 1.28335 82.8219 1.28335 73.1449V20.3612C1.28335 10.6842 9.20091 2.76667 18.8779 2.76667H71.6615C81.3386 2.76667 89.2561 10.6842 89.2561 20.3612V40.3879C89.2561 40.3879 55.5774 21.0665 26.5117 67.3336C26.5117 67.3336 28.9623 69.5636 30.9318 66.4161M80.7544 33.7634L83.5385 25.3704C81.2139 24.8325 79.1015 24.4706 76.246 24.2484V33.0804C78.0437 33.2454 79.2267 33.4432 80.7544 33.7634ZM66.1509 33.2294L66.0325 24.3876C63.6599 24.6407 61.5455 24.9907 58.7747 25.7159L61.6675 34.0608C63.4201 33.6279 64.6026 33.4273 66.1509 33.2294ZM52.0792 37.5743L49.1417 29.2338C46.9744 30.2317 45.0826 31.239 42.6889 32.8117L48.0965 39.7947C49.619 38.8245 50.6754 38.2565 52.0792 37.5743ZM39.3152 46.2186L34.3524 38.8998C32.5103 40.4163 30.9371 41.8717 29.0222 44.0016L36.0284 49.3791C37.254 48.0535 38.1311 47.2355 39.3152 46.2186Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3067 34.4898L66.1839 25.1667C63.7232 25.4335 61.5304 25.8026 58.6569 26.5673L61.6569 35.3664C63.4746 34.91 64.701 34.6984 66.3067 34.4898Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.282 38.3218L49.0913 30.2665C46.7371 31.2304 44.6823 32.2032 42.0823 33.7221L47.956 40.4663C49.6097 39.5292 50.7571 38.9807 52.282 38.3218Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8812 26.2191C80.8491 25.7145 79.0025 25.3751 76.5064 25.1667V33.4508C78.0779 33.6056 79.112 33.7911 80.4474 34.0914L82.8812 26.2191Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5324 47.2053L34.6146 39.1913C32.7892 40.8518 31.2302 42.4455 29.3327 44.7777L36.2754 50.666C37.4899 49.2145 38.359 48.3188 39.5324 47.2053Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_133_4205",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 40,
    width: 59,
    height: 38
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6435 44.6501C87.567 44.603 79.8748 39.9462 69.1053 40.6364C62.8387 41.0384 56.7179 43.1554 50.9125 46.929C44.5834 51.043 38.5996 57.1461 33.0793 65.1096C35.0943 66.2461 40.1853 68.9103 47.7116 71.4364C56.7885 74.483 71.3765 77.9495 89.3358 77.1617L91.3446 46.0791L87.6435 44.6501Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_133_4205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.8725 47.1852C87.8725 56.9519 79.6284 64.8694 69.4589 64.8694C59.2893 64.8694 51.0452 56.9519 51.0452 47.1852C51.0452 37.4185 59.2893 29.501 69.4589 29.501C79.6284 29.501 87.8725 37.4185 87.8725 47.1852ZM79.5652 47.1852C79.5652 41.97 75.0315 37.727 69.4588 37.727C63.8862 37.727 59.3526 41.97 59.3526 47.1852C59.3526 52.4004 63.8862 56.6433 69.4588 56.6433C75.0315 56.6433 79.5652 52.4004 79.5652 47.1852Z",
    fill: "url(#paint0_linear_133_4205)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5168 65.515C39.0131 57.5954 44.971 51.5259 51.2726 47.4346C57.0527 43.6817 63.147 41.5764 69.3864 41.1766C80.1092 40.4902 87.7681 45.1213 87.8442 45.1682L89.2561 45.7127L89.2546 40.6602C89.2546 40.6602 55.7222 21.2567 26.7827 67.7203C26.7827 67.7203 29.2226 69.9597 31.1836 66.7989C31.1836 66.7989 52.3297 79.2772 74.6645 77.2089C63.5731 76.2882 54.4621 73.9446 48.0856 71.8069C40.592 69.2947 35.523 66.6452 33.5168 65.515Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_133_4205",
    x1: 54.2947,
    y1: 47.3144,
    x2: 87.8815,
    y2: 57.9529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0062FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSquare);
export default __webpack_public_path__ + "static/media/icon-square.bbe7537e3929f3a90958d9c21cc42038.svg";
export { ForwardRef as ReactComponent };